import React, {Fragment, useState,useEffect} from 'react'
import axios from 'axios';
import globals from 'react-global-configuration';
import {LoginForm} from '../components/LoginForm'
import Context from '../Context'


export const Login = (props) => {


    //si existe sessionstage saltar login
    var firstName = sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`)
    //console.log('firstName',firstName)
    const _URL_REST = globals.get('_URL_REST');
    let [loaddata, setloaddata] = useState(null)
    const [listSettings, setSettings] = useState(false);
    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`,
        );
        setSettings(result.data[0])
    };
  
    useEffect(() => {
        fetchSettings();
    },[]);

    useEffect(() => {
        //axios wait
        async function fetchData() {
        
            var url_string = window.location.href
            var url = new URL(url_string);
            var c = url.searchParams.get("code")
            let md5pass = c

            if(md5pass !== null ){
                if(md5pass.length  == 15){
                    var addon="";
                    for(var block=0;block<3; block++)
                    {
                        var loop=0;
                        for(var position=0;position<5;position++){
                            var current=md5pass.charAt(block*5+position);
                            if(current>="A" && current<="Z")
                                loop+=1<<position;
                        }
                        addon+="ABCDEFGHIJKLMNOPQRSTUVWXYZ012345".charAt(loop);
                    }
                    md5pass=(md5pass+addon);
                }
            }


            if(c !== null ){

                try {
                    var dataForm = {
                        claveUsuario: md5pass,
                    };
                    const url = `https://eventosonline.spinmedia.es/api/auth/loginSF/`
                    const requestOptions = {
                      method: 'POST',
                      body: JSON.stringify(dataForm),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },  
                    }
                    let respuesta = await fetch(url, requestOptions)
                    let resultado = await respuesta.json()
                    console.log('LOGIN::',resultado.data)
                    setloaddata(true);
                    sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`, resultado.data.idUsuario) 
                    sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_NAMEUSERRADIO`, resultado.data.nombre) 
                    sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_TOKENUSERRADIO`, resultado.data.token) 
                    sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`, md5pass)
                    sessionStorage.setItem(`${process.env.REACT_APP_EVENTO_ID}index-EMAIL`, resultado.data.email)

                    let bajodemanda = false
                    listSettings.streaming ? bajodemanda = false : bajodemanda = true
                    var dataFormlog = {  
                        "idUsuario": sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`),
                        "idEvento": process.env.REACT_APP_EVENTO_ID,
                        "ip": "192.168.1.1",
                        "BajoDemanda": bajodemanda,
                        "Navegador": `${window.navigator.userAgent}`
                    }

                    const urllog = `https://eventosonline.spinmedia.es/api/eventos/GrabarEventoLog`
                    const requestOptionslog = {
                      method: 'POST',
                      body: JSON.stringify(dataFormlog),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':`Bearer ${sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_TOKENUSERRADIO`)}`
                      },  
                    }
                    let respuestalog = await fetch(urllog, requestOptionslog)
                    let resultadolog = await respuestalog.json()


                    props.activateAuth()
                  } catch (error) {
                    console.log('Error: ', error)
                    setloaddata(false);
                  }

            }
            
        }
        fetchData();
    }, [_URL_REST]);

    if( firstName === null){
        console.log("is login?")
    }else{
        props.activateAuth()
    }


    return(

        <Context.Consumer>
            {
                ({isAuth, activateAuth}) => {
                    if(isAuth){
                        if(!listSettings.eventoActivo){
                            return(
                                <Fragment>
                                    <LoginForm activateAuth={activateAuth} />
                                </Fragment>
                            )
                        }else{
                            setTimeout(function(){
                                //console.log('check again')
                                fetchSettings();
                            },30000);
                              
                            return (<div>
                                        <div style={{margin: "40px 0",'text-align': 'center','font-size':'24px'}} className="xtinicio">{listSettings.eventoActivoTXT}</div>
                                    </div>)
                        }
                    }else{
                        return(
                            <Fragment>
                                <LoginForm activateAuth={activateAuth} />
                            </Fragment>
                        )
                    }    
                }
            }
        </Context.Consumer>
    )
        
    
}


